module.exports = __webpack_public_path__ + "img/no-items2.cccd6ebb.svg";